import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {getUsers} from "../ducks/user";
import {getCourtCorrections} from "../firebase";
import {isObjectEmpty} from "../utils/utils";
import {Loader} from "../components/loader";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";


export function CourtCorrections() {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const users = useSelector((state) => state.user.users);

    const columns = [
        {
            field: 'fullName',
            headerName: 'Full Name',
            width: 160,
            valueGetter: (params) => `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'oldCourtInfo',
            headerName: 'Court Name',
            width: 400,
            valueGetter: (params) => params.row.oldCourtInfo?.name,
            renderCell: (params) => (
                <Tooltip title={params?.value}>
                    <span>{params?.value}</span>
                </Tooltip>
            ),
        },
    ];

    useEffect(() => {
        const getData = async () => {
            if (users.length == 0) {
                setIsLoading(true);

                dispatch(getUsers());
            }
        };

        getData();
    }, [dispatch]);

    useEffect(() => {
        const getData = async () => {

            if (users.length == 0) {
                return;
            }

            let courtCorrections = await getCourtCorrections();
            await transformData(courtCorrections);
            setIsLoading(false);
        };

        getData();
    }, [users]);

    const transformData = async (courtCorrections) => {
        let mergedCourtCorrectionData = {};
        for (const [userId, courtCorrectionInfo] of Object.entries(courtCorrections)) {
            console.log('courtCorrectionInfo', courtCorrectionInfo)

            for (const [courtId, courtCorrectionData] of Object.entries(courtCorrectionInfo)) {
                console.log('courtCorrectionData', courtId, courtCorrectionData)

                let userInfo = users.find(user => userId == user.id)
                courtCorrectionData.submittedByUser = userInfo;
                mergedCourtCorrectionData[courtId] = courtCorrectionData;
            }
        }

        console.log('mergedCourtCorrectionData', mergedCourtCorrectionData)

        let rowData = [];
        for (const [courtId, courtCorrectionData] of Object.entries(mergedCourtCorrectionData)) {
            let user = courtCorrectionData.submittedByUser;

            if (isObjectEmpty(user)) {
                console.log('WARNING: Could not find user', user)
                continue;
            }

            let row = {
                id: courtId,
                firstName: user.firstName,
                lastName: user.lastName,
                additionalNotes: courtCorrectionData.additionalNotes,
                noLongerExists: courtCorrectionData.noLongerExists,
                oldCourtInfo: courtCorrectionData.oldCourtInfo,
                newCourtInfo: courtCorrectionData.newCourtInfo,
            };

            rowData.push(row);
        }

        setRows(rowData);
    };

    const onRowClicked = (params) => {
        console.log('onRowClicked', params)
        navigate(`/court-corrections-detail/${params.id}`, { state: {...params.row}});
    }

    if (isLoading) {
        return (<Loader/>);
    }

    return (
        <>
            <Box height="100vh" display="flex" flexDirection="column">
                <DataGrid
                    sx={{
                        boxShadow: 2,
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    rows={rows}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    checkboxSelection
                    disableSelectionOnClick
                    experimentalFeatures={{newEditingApi: true}}
                    onRowClick={onRowClicked}
                />
            </Box>
        </>
    );
};